<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Find A Partner Revenue<span class="badge">{{ totalRecords }}</span></h4>
        </div>
        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>Export</button>
        </div>
      </div>
      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadFAPRReports(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
            <div class="divider ">
            <hr>
          </div>
           <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                  (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
                 <li>
                   <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                  (onChange)="getCities($event)" placeholder="Select State" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                <li>
                    <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                  (onChange)="loadFAPRReports(lastTableLazyLoadEvent)" placeholder="Select City" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="cityName"></p-dropdown>
                </li> 
                <li>
              <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                  (onChange)="onSportChange($event)" placeholder="Select Sport" optionLabel="name"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="sportName"></p-dropdown>
                </li>
               
              </ul>
            </div>
          </div>
           <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{totalRecords}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Partners Booked</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalPartnersBooked}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Booking Cities</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalNumberOfBookingCities}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Cost</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalCost}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (Partner)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalCouponAmountPartner}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (TPL)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalCouponAmountTPL}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Revenue</h6>
                  </div>
                  <div class="mainText">
                    <h3> {{faprlist?.summary?.totalTPLRevenue}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Commission Amount</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalTPLCommissionAmount}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total User Payout</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalUserPayout}}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Share</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{faprlist?.summary?.totalTPLShare}}</h3>
                  </div>
              </div>
            </li>
          </ul>
        </div> 
         
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="faprlist?.data" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadFAPRReports($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th class="userNameTD" pSortableColumn="userCity">
                    <div class="p-d-flex p-jc-between p-ai-center"> User City <p-sortIcon
                        field="userCity"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="partnerName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Partner Name <p-sortIcon
                        field="partnerName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingId"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking ID <p-sortIcon field="bookingId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="playerCoachPaidHits">
                    <div class="p-d-flex p-jc-between p-ai-center"> Player/Coach/Paid Hits <p-sortIcon
                        field="playerCoachPaidHits"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingCity">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking City <p-sortIcon
                        field="bookingCity"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingState" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking State <p-sortIcon
                        field="bookingState"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bookingCountry" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Booking Country <p-sortIcon
                        field="bookingCountry"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="dateOfBooking" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Date of Booking <p-sortIcon
                        field="dateOfBooking"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="sessionStartTime" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Session Start Time <p-sortIcon
                        field="sessionStartTime"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="sessionEndTime" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Session End Time <p-sortIcon
                        field="sessionEndTime"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="costPerHour" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Cost Per Hour <p-sortIcon
                        field="costPerHour"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="totalCost" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Total Cost <p-sortIcon
                        field="totalCost"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponApplied" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Applied <p-sortIcon
                        field="couponApplied"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountPartner" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (Partner) <p-sortIcon
                        field="couponDiscountAmountPartner"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountTPL" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (TPL) <p-sortIcon
                        field="couponDiscountAmountTPL"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplRevenue" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Revenue <p-sortIcon
                        field="tplRevenue"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="gstAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon
                        field="gstAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommissionPercent" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission % <p-sortIcon
                        field="tplCommissionPercent"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplCommissionAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission Amount <p-sortIcon
                        field="tplCommissionAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="userPayout" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> User Payout <p-sortIcon
                        field="userPayout"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="tplShare" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Share <p-sortIcon
                        field="tplShare"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userCity', 'contains')"
                      [value]="dt.filters['userCity'] ? dt.filters['userCity'].value : ''" />
                  </th>
                  <th class="transferCreditTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'partnerName', 'contains')"
                      [value]="dt.filters['partnerName'] ? dt.filters['partnerName'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingId', 'contains')"
                      [value]="dt.filters['bookingId'] ? dt.filters['bookingId'].value : ''" />
                  </th>
                  <th class="BankDteailsTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'playerCoachPaidHits', 'contains')"
                      [value]="dt.filters['playerCoachPaidHits'] ? dt.filters['playerCoachPaidHits'].value : ''" />
                  </th>
                  <th class="BankDteailsTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingCity', 'contains')"
                      [value]="dt.filters['bookingCity'] ? dt.filters['bookingCity'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingState', 'contains')"
                      [value]="dt.filters['bookingState'] ? dt.filters['bookingState'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'bookingCountry', 'contains')"
                      [value]="dt.filters['bookingCountry'] ? dt.filters['bookingCountry'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'dateOfBooking', 'equals')"
                      [value]="dt.filters['dateOfBooking'] ? dt.filters['dateOfBooking'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="time"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'sessionStartTime', 'equals')"
                      [value]="dt.filters['sessionStartTime'] ? dt.filters['sessionStartTime'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="time"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'sessionEndTime', 'equals')"
                      [value]="dt.filters['sessionEndTime'] ? dt.filters['sessionEndTime'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'costPerHour', 'equals')"
                      [value]="dt.filters['costPerHour'] ? dt.filters['costPerHour'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'totalCost', 'equals')"
                      [value]="dt.filters['totalCost'] ? dt.filters['totalCost'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponApplied', 'contains')"
                      [value]="dt.filters['couponApplied'] ? dt.filters['couponApplied'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountPartner', 'equals')"
                      [value]="dt.filters['couponDiscountAmountPartner'] ? dt.filters['couponDiscountAmountPartner'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountTPL', 'equals')"
                      [value]="dt.filters['couponDiscountAmountTPL'] ? dt.filters['couponDiscountAmountTPL'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplRevenue', 'equals')"
                      [value]="dt.filters['tplRevenue'] ? dt.filters['tplRevenue'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstAmount', 'equals')"
                      [value]="dt.filters['gstAmount'] ? dt.filters['gstAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionPercent', 'equals')"
                      [value]="dt.filters['tplCommissionPercent'] ? dt.filters['tplCommissionPercent'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionAmount', 'equals')"
                      [value]="dt.filters['tplCommissionAmount'] ? dt.filters['tplCommissionAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userPayout', 'equals')"
                      [value]="dt.filters['userPayout'] ? dt.filters['userPayout'].value : ''" />
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplShare', 'equals')"
                      [value]="dt.filters['tplShare'] ? dt.filters['tplShare'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element action-button-td"  style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-faprlist>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{faprlist.mobileNumber}}" tooltipPosition="bottom">
                      {{faprlist.mobileNumber}}
                    </div>
                  </td>
                  <td class="userNameTD">
                    {{ faprlist.username }}
                  </td>      
                  <td class="userNameTD">
                    {{ faprlist.userCity ? faprlist.userCity.name : '' }}
                  </td>   
                  <td class="transferCreditTD">
                    {{ faprlist.partnerName }}
                  </td>   
                  <td class="BankDteailsTD">
                    {{ faprlist.bookingId }}
                  </td>   
                  <td class="BankDteailsTD">
                    {{ faprlist.playerCoachPaidHits }}
                  </td>   
                  <td class="BankDteailsTD">
                    {{ faprlist.bookingCity }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.bookingState }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.bookingCountry }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.dateOfBooking | date : "dd/MM/yyyy" }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.sessionStartTime | date : "hh:mm a" }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.sessionEndTime | date : "hh:mm a" }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.costPerHour }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.totalCost }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.couponApplied ? 'Yes' : 'No' }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.couponDiscountAmountPartner }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.couponDiscountAmountTPL }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.tplRevenue }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.gstAmount }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.tplCommissionPercent }} %
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.tplCommissionAmount }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.userPayout }}
                  </td>   
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ faprlist.tplShare }}
                  </td>      
                  <td class="text-nowrap p-element action-button-td">
                    
                  </td>         
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="24">Find a partner revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
